const MeetingStatus = {
    Loading: 'LOADING',
    Succeeded: 'SUCCEEDED',
    Failed: 'FAILED',
};
export default MeetingStatus;
